import React from 'react';

interface SkeletonProps {
  className?: string;
  variant?: 'rect' | 'circle';
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  variant = 'rect',
}) => {
  const shapeClass = variant === 'circle' ? 'rounded-full' : 'rounded-lg';
  return (
    <div
      className={`skeleton ${shapeClass} ${className}`.trim()}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
